const SUITS = ["c", "s", "d", "h"];

export function createDeck() {
  const deck = [];
  for (const suit of SUITS) {
    for (let rank = 0; rank <= 12; rank++) {
      deck.push([rank, suit]);
    }
  }
  return deck;
}

export function shuffleDeck(deck) {
  const d = deck.slice();
  for (let i = d.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [d[i], d[j]] = [d[j], d[i]];
  }
  return d;
}

export function dealCards(deck, count) {
  return {
    cards: deck.slice(0, count),
    remaining: deck.slice(count),
  };
}
